module.exports = __webpack_public_path__ + "img/buyers_expressed interest.edbfa51e.svg";